import React from 'react';

const ClipboardComponent = () => (
  <textarea
    data-clipboard
    style={{
      position: 'fixed',
      top: '-2em',
      left: '-2em',
      width: '2em',
      height: '2em',
      padding: 0,
      border: 'none',
      outline: 'none',
      background: 'transparent'
    }}
  />
);

export default ClipboardComponent;


// WEBPACK FOOTER //
// src/Components/ClipboardComponent.jsx